import { api } from '@/lib/api';
import type {
  CxWatchItem,
  DashboardStats,
  DisputeRiskItem,
  GeoBreakdownBucket,
  TicketSummary,
  WorkloadItem
} from '@/types/api';

export const dashboardApi = {
  stats: () => api.get<DashboardStats>('/dashboard/stats'),
  disputeRisk: () => api.get<DisputeRiskItem[]>('/dashboard/dispute-risk'),
  workload: () => api.get<WorkloadItem[]>('/dashboard/workload'),
  cxWatch: () => api.get<CxWatchItem[]>('/dashboard/cx-watch'),
  approvals: () => api.get<TicketSummary[]>('/dashboard/approvals'),
  myQueue: () => api.get<TicketSummary[]>('/dashboard/my-queue'),
  // V4.9.10 — Per-geo card breakdown for the Dashboard.
  geoBreakdown: () => api.get<GeoBreakdownBucket[]>('/dashboard/geo-breakdown')
};
